<template>
    <div id="home-mobile">
        <a name="s-home" id="s-home"></a>
        <div class="just-a-wrap">
            <div class="banner" id="section-banner">
                <transition name="fade">
                    <div v-if="false" class="nav">
                        <ul>
                            <li @click="gotoSection('s-home')"><a>首页</a></li>
                            <li><a class="nav-link" href="/explore/2017cusc/news/" target="_blank">大会现场</a></li>
                            <li @click="gotoSection('s-guest')"><a>参会嘉宾</a></li>
                            <li @click="gotoSection('s-agenda')"><a>会议议程</a></li>
                            <li @click="gotoSection('s-tickets')"><a>参会购票</a></li>
                            <li @click="gotoSection('s-partners')"><a>合作机构</a></li>
                            <li @click="gotoSection('s-location')"><a>场地信息</a></li>
                            <li @click="gotoSection('s-contact-us')"><a>联系我们</a></li>
                        </ul>
                    </div>
                </transition>
            </div>

            <div class="section guest" id="section-guest">
                <a id="s-guest"></a>
                <div class="s-title"> <img src="../assets/n-m/m-title-guest2-wap.png"> </div>
                <ul class="guest-list">
                    <li v-for="guest in guestList">
                        <div class="photo">
                            <img :src="guest.photo" alt="嘉宾姓名">
                        </div>
                        <div class="name-wrap">
                            <div class="name">{{ guest.name }}</div>
                            <div class="company">
                                <div class="position">
                                    {{ guest.position }}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>


            <div id="agenda-bg-area">
                <div class="section agenda" id="section-agenda">
                    <a id="s-agenda"></a>
                    <div class="s-title"> <img src="../assets/n-m/m-title-agenda.png"> </div>
                    <template v-if="agendaData.type[0]">
                        <div v-for="(key, index) in agendaData.type[0]" :class="'agenda-item-'+ index">
                            <div :class="'conf-host-'+index" class="conf-host">
                                <div class="title">{{ key.split("|")[0] }}</div>
                                <div class="summary" v-if="key.split('|')[1]">{{ key.split("|")[1] }} </div>
                            </div>
                            <div class="agenad-list">
                                <template v-for="agenda in agendaData.meeting[key]">
                                    <agenda-item :data="agenda" :index="index"></agenda-item>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="section agenda" id="section-agenda">
                    <div class="s-title"> <img src="../assets/n-m/m-title-agenda2.png"> </div>
                    <template v-if="agendaData.type[1]">
                        <div v-for="(key, index) in agendaData.type[1]" :class="'agenda-item-'+ index">
                            <div :class="'conf-host-'+index" class="conf-host">
                                <div class="title">{{ key.split("|")[0] }}</div>
                                <div class="summary" v-if="key.split('|')[1]">{{ key.split("|")[1] }} </div>
                            </div>
                            <div class="agenad-list">
                                <template v-for="agenda in agendaData.meeting[key]">
                                    <agenda-item :data="agenda" :index="index"></agenda-item>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>


            <!-- tickets  -->
            <div class="section tickets">
                <p id="s-tickets"></p>
                <div class="s-title"> <img src="../assets/n-m/m-title-tickets.png"> </div>

                <span class="no-more-invoice">12月20日之后将不再提供本次活动的发票</span>

                <a class="rogers-area" href="https://jinshuju.net/f/Jlf1js" target="_blank">
                    <div class="rogers">
                        <img src="../assets/n-m/m-rogers.png">
                    </div>
                    <div class="ticket-info">
                        <div class="name">
                            尊享票
                        </div>
                        <div class="price-line">
                            <span class="price"> 36666元</span>
                            <span class="count"> 限10位名额</span>
                        </div>
                        <div class="intro-line">
                            <ul>
                                <li>与国际著名投资大师吉姆·罗杰斯半天闭门沟通会 </li>
                                <li>SSVIP尊享座位，2天通票 </li>
                                <li>闭门晚宴入场券，与全球最强创投大脑亲密social </li>
                                <li>限企业/投资机构创始人、高管报名，需要审核 </li>
                            </ul>
                        </div>
                    </div>
                    <div class="buy-btn">
                        立即购票
                    </div>
                </a>

                <div class="tickets-content">
                    <a class="ticket0" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              早鸟参会票
                            </div>
                            <div class="price">
                              99元&nbsp;
                            </div>
                            <div class="content">
                              2天通票，尽享4场论坛，20+主题演讲 <br>
                              4000平米展览互动体验<br>
                              座位先到先得<br>
                            </div>
                            <div class="bottom-area">
                                <div class="seat">
                                  有限席位
                                </div>
                                <div class="buy-btn">
                                    立即购票
                                </div>
                            </div>
                        </div>
                    </a>
                    <a class="ticket1" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              2天峰会通票
                            </div>
                            <div class="price">
                              199元&nbsp;
                            </div>
                            <div class="content">
                              2天通票，尽享4场论坛，20+主题演讲 <br>
                              4000平米展览互动体验<br>
                              座位先到先得<br>
                            </div>
                            <div class="bottom-area">
                                <div class="seat">
                                  有限席位
                                </div>
                                <div class="buy-btn">
                                    立即购票
                                </div>
                            </div>
                        </div>
                    </a>
                    <a class="ticket2" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              CEO 票
                            </div>
                            <div class="price">
                              899元&nbsp;
                            </div>
                            <div class="content">
                                2天通票，尽享4场论坛，20+主题演讲<br>
                                 4000平米展览互动体验<br>
                                保证前排座位<br>
                                演讲嘉宾可公开 PPT 独家分享<br>
                            </div>
                            <div class="bottom-area">
                                <div class="seat">
                                  有限席位仅限CEO参加
                                </div>
                                <div class="buy-btn">
                                    立即购票
                                </div>
                            </div>
                        </div>
                    </a>
                    <a class="ticket3" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              晚宴入场券
                            </div>
                            <div class="price">
                              9999元&nbsp;
                            </div>
                            <div class="content">
                              闭门晚宴入场券，与全球最强创投大脑亲密 social<br>
                              2天通票，尽享4场论坛，20+主题演讲 4000平米展览互动体验<br>
                              保证前排座位<br>
                              演讲嘉宾可公开 PPT 独家分享<br>
                            </div>
                            <div class="bottom-area">
                                <div class="seat">
                                  有限席位
                                </div>
                                <div class="buy-btn">
                                    立即购票
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <!-- old guests -->
            <div id="old-guest-bg-area" v-if="false">
                <div class="section old-guests">
                    <p id="s-old-guest"></p>
                    <div class="s-title"> <img src="../assets/n-pc/title-old-guests.png"> </div>
                    <div class="container">
                        <div v-for="item in oldGuests" class="old-guest-item">
                            <img :src="item.img">
                            <div class="guest-name"> {{ item.name }} </div>
                            <div class="guest-title"> {{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- faq -->
            <div id="faq-bg-area">
                <div class="section faq">
                    <p id="s-faq"></p>
                    <div class="s-title"> <img src="../assets/n-m/m-title-faq.png"> </div>
                    <div class="container">
                        <div class="faq-item">
                            <div class="line-q">
                                <span>Q:</span>
                                <div class="content">
                                    购票什么时候截止?
                                </div>
                            </div>
                            <div class="line-a">
                                <span>A:</span>
                                <div class="content">
                                    购票截止日期为2017年12月3日。
                                </div>
                            </div>

                            <div class="line-q">
                                <span>Q:</span>
                                <div class="content">
                                    购票付款成功后，如何获得参会凭证？
                                </div>

                            </div>
                            <div class="line-a">
                                <span>A:</span>
                                <div class="content">
                                    在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。 <br>
                                    活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌创业课堂（微信号：xfzkf008），届时也会有相应的提醒。
                                </div>
                            </div>

                            <div class="line-q">
                                <span>Q:</span>
                                <div class="content">
                                    是否可以申请发票？
                                </div>
                            </div>
                            <div class="line-a">
                                <span>A:</span>
                                <div class="content">
                                    当您的购票订单付款成功后，会有相应的申请发票入口。也可 <a href="http://www.xfz.cn/order/" target="_blank" style="color: #fff;">点此申请发票</a>，在相应的订单下方点击申请发票即可。
                                </div>
                            </div>
                            <div class="line-a">
                                <div class="sa-title">温馨提示：</div>
                                <div class="sa-content">
                                    1) 大会门票仅开具增值税发票，不提供增值税专用发票；<br>
                                    2) 开票内容为：会议服务费 <br>
                                    3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。<br>
                                </div>
                            </div>

                            <template v-if="showMoreFaq">
                            <div class="line-q"> <span>Q:</span>
                                <div class="content">
                                    观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？
                                </div>
                            </div>
                            <div class="line-a"> <span>A:</span>
                                <div class="content">
                                    请您核对票务权益，早鸟票、峰会通票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。
                                </div>
                            </div>

                            <div class="line-q"> <span>Q:</span>
                                <div class="content">
                                    大会现场有同声传译服务吗？如何领取同传设备？
                                </div>
                            </div>
                            <div class="line-a"> <span>A:</span>
                                <div class="content">
                                    有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。
                                </div>
                            </div>

                            <div class="line-q"> <span>Q:</span>
                                <div class="content">
                                    大会场馆附近有就餐的地方吗？
                                </div>
                            </div>
                            <div class="line-a"> <span>A:</span>
                                <div class="content">
                                    酒店6层设有自助餐厅；距会场2-7分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅灯，价位不等，有多样选择。
                                </div>
                            </div>
                            </template>
                            <div class="faq-more-btn" @click="showMoreFaq = !showMoreFaq">
                                <span v-if="!showMoreFaq">查看更多</span><span v-else>点击收起</span></div>
                        </div>
                    </div>
                </div>
            </div>



            <!-- partners -->
            <div class="section partners">
                <a name="s-partners" id="s-partners"></a>
                <div class="s-title"> <img src="../assets/n-m/m-title-partners.png"> </div>
                <div class="container">
                    <a name="s-partners"></a>
                    <div class="up-title"></div>
                    <div class="title"></div>
                    <dl>
                        <template v-for="partner in partnerList">
                            <template v-for="(val, key) in partner">
                                <dt>{{ key }}</dt>
                                <dd>
                                    <img v-for="pic in val" :src="pic.logo + '-fintech.partner'">
                                </dd>
                            </template>
                        </template>
                    </dl>
                </div>
            </div>

            <!-- location -->
            <div class="section location">
                <a name="s-location" id="s-location"></a>

                <div class="s-title"> <img src="../assets/n-m/m-title-address.png"> </div>

                <div class="location-wrap"></div>

            </div>

            <div class="section about-us">
                <a name="s-contact-us" id="s-contact-us"></a>
                <div style="height: 25px;"></div>
                <div class="s-title"> <img src="../assets/n-m/m-title-contact-us.png"> </div>
                <div class="about-us-wrap">

                    <div class="user-item">
                        <div class="title">赞助合作</div>
                        <div class="name">杨福群</div>
                        <div class="phone">158-0116-1560</div>
                        <div class="email">fuqun@xfz.cn</div>
                    </div>

                    <div class="user-item">
                        <div class="title">媒体合作</div>
                        <div class="name">徐洋</div>
                        <div class="phone">188-1053-9975</div>
                        <div class="email">xuyang@xfz.cn</div>
                    </div>

                    <div v-if="false" class="user-item">
                        <div class="title">票务合作</div>
                        <div class="name">王艳</div>
                        <div class="phone">187-0117-2011</div>
                        <div class="email">wangyan@xfz.cn</div>
                    </div>

                    <div class="qrcode">
                        <img src="http://static-image.xfz.cn/explore/images/qrcode.jpg">
                        <div class="qrcode-info">
                            <span>扫描二维码<br>
                            关注小饭桌公众号</span>
                        </div>
                    </div>
                </div>
            </div>

            <transition name="fade">
                <div class="bottom-buy-link-float" v-if="showBottomNav">
                    <a class="bottom-nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-guest">
                    </a>
                    <a class="bottom-nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-agenda">
                    </a>

                    <a class="bottom-nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="http://www.xfz.cn/explore/xfz2017/news/" target="_blank">
                    </a>

                    <a v-if="false" class="bottom-nav-link" target="_blank" data-options='{ "easing": "easeInQuad" }'
                        :href="ticketUrl">
                    </a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import AgendaItem from "./MobileAgendaItem"
import TicketItem from "./MobileTicketItem"
import util from '../assets/js/util'
import oldGuests from '../assets/js/guest_data'

export default{
    components:{
        AgendaItem,TicketItem
    },
    data(){
        return{
            whichDay: 'Day1',
            showMenu: false,
            guestList: [],
            agendaData: {
                type:[]
            },
            whichConf: '',
            whichHost: '',
            partnerList: [],
            currentAgendaMenu:[],
            activeAgendaMenu:'',
            currentAgendaData:[],
            showMoreFaq: false,
            showBottomNav: false,
            oldScrollY: 0,
            newScrollY: 0,
            oldGuests: oldGuests,
            ticketUrl: "http://www.xfz.cn/apply/conference/?code=sELZA0vN2i&t=2017-11-21-11:48:24",
        }
    },
    methods:{
        addListenScroll(){
            var self = this
            window.onscroll = function (e) {

                self.newScrollY = window.scrollY
                if(self.newScrollY - self.oldScrollY > 0) {
                    self.showBottomNav = false
                } else {
                    self.showBottomNav = true
                }
                self.oldScrollY = self.newScrollY
            }
       },
        getGuestData() {
            var self = this
            util.resource({
                url: '/explore/xfz2017_api/guest/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.guestList = res.data
                    }
                }
            })
        },
        getPartnerData() {
            var self = this
            util.resource({
                url: '/explore/xfz2017_api/company/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.partnerList = res.data
                    }
                }
            })
        },
        getAgendaData() {
            var self = this
            util.resource({
                url: '/explore/xfz2017_api/meeting/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.agendaData = res.data
                        self.currentAgendaMenu = self.agendaData.type[0] ? self.agendaData.type[0]: []
                        self.activeAgendaMenu = self.agendaData.type[0][0] // 默认显示第一个议程
                        self.changeCurrentAgenda(self.activeAgendaMenu)
                    }
                }
            })
        },
        changeCurrentAgenda(agenda){
            this.activeAgendaMenu = agenda
            this.currentAgendaData = this.agendaData.meeting[agenda]
            this.whichConf = agenda.split("|")[0]
            this.whichHost = agenda.split("|")[1]
        },
        gotoSection(section){
            $("html,body").animate({scrollTop: $("#" + section).offset().top}, 1000);
        },
    },
    mounted(){
        document.title = '2017小饭桌全球青年创业者大会'
        this.addListenScroll()
        this.getGuestData()
        this.getAgendaData()
        this.getPartnerData()
        util.getWx()
    }
}

</script>

<style lang="scss" scoped>
@media screen and (min-width: 280px) {html{font-size:74.6px;}}
@media screen and (min-width: 320px) {html{font-size:85.33px;}}
@media screen and (min-width: 360px) {html{font-size:96px;}}
@media screen and (min-width: 375px) {html{font-size:100px;}}
@media screen and (min-width: 414px) {html{font-size:110.4px;}}
@media screen and (min-width: 440px) {html{font-size:117.33px;}}
@media screen and (min-width: 480px) {html{font-size:128px;}}
@media screen and (min-width: 520px) {html{font-size:138.66px;}}
@media screen and (min-width: 540px) {html{font-size:144px;}}
@media screen and (min-width: 600px) {html{font-size:160px;}}
@media screen and (min-width: 768px) {html{font-size:208.4px;}}

#home-mobile{
    font-size: .12rem;
    .banner{
        margin-top: 20px;
        height: 1.4rem;
        color: #fff;
        background:{
            image: url('../assets/n-m/m-banner2.png');
            repeat: no-repeat;
            size:100%;
        }
        .nav{
            background-color: rgba(0,0,0,0.3);
            // position: fixed;
            // z-index: 199;
            ul{
                white-space: nowrap;
                overflow: auto;
                display: block;
                padding-left: 10px;
                li{
                    display: inline;
                    font-size: .15rem;
                    height: .4rem;
                    line-height: .4rem;
                    margin-right: 10px;
                    list-style: none;
                    a{
                        text-decoration: none;
                        color: #fff;
                    }
                    .slogan-wrap{
                        // background-color: #ccc;
                        display: inline;
                        float: left;
                        padding-left: .1rem;
                        height: .4rem;
                        img{
                            display: inline-block;
                            height: .16rem;
                        }
                        .slogan{
                            font-size: .1rem;
                            line-height: .1rem;
                            padding: 0;
                            margin-bottom: 1px;
                            display: block;
                        }
                    }
                }
            }
            ul::-webkit-scrollbar{
                display: none;
            }
        }
    }
    .guest{
        overflow: hidden;
        margin-bottom: 10px;
        ul.guest-list {
            text-align: left;
            width: 95%;
            // max-width: 390px;
            margin: 0 auto;
            overflow: visible;
            // background-color: #ccc;
            li {
                // background-color: grey;

                -webkit-transform: skewX(-30deg);
                -ms-transform: skewX(-30deg);
                transform: skewX(-30deg);
                -webkit-transform-origin: left bottom;
                -ms-transform-origin: left bottom;
                transform-origin: left bottom;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;

                width: .9rem;
                height: 1.59rem;
                vertical-align: top;
                display: block;
                display: inline-block;
                // background-color: red;
                 .photo {
                    transform: skewX(30deg) translateZ(-1px);
                    left: -49%;
                    overflow: visible;
                    // overflow: hidden;
                    // background-color: red;
                    position: relative;
                    width: 1.4rem;
                    height: 100%;
                    img {
                        display: block;
                        width: 1.77rem;
                        // height: 1.24rem;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 99;
                        position: absolute;
                    }
                }
                .name-wrap{
                    margin-top: -0.616rem;
                    color: #ffffff;
                    position: relative;
                    background-image: url('../assets/n-m/m-avatar-bg-active4.png');
                    background-repeat: no-repeat;
                    height: .6rem;
                    width: .9rem;
                    text-align: left;
                    margin-left: -1px;
                    background-size: cover;
                    .name {
                        -webkit-transform: skewX(30deg) translateZ(2px);
                        transform: skewX(30deg) translateZ(2px);
                        font-weight: bold;
                        font-size: .12rem;
                        position: absolute;
                        text-align: center;
                        top: .12rem;
                        right: 0;
                        left: 0;
                        // border: 1px solid green;
                    }
                    .company {
                        // border: 1px solid yellow;
                        -webkit-transform: skewX(30deg) translateZ(2px);
                        transform: skewX(30deg) translateZ(2px);
                        right: 0;
                        left: 0;
                        top: .26rem;
                        bottom: 0;
                        width: 100%;
                        text-align: center;
                        position: absolute;
                        line-height: 1;
                        padding: 0 6px;
                        font-size: .092rem;
                        display: table;
                        // background-color: grey;

                        .position {
                            width: 100%;
                            // border: 1px solid green;
                            display: table-cell;
                            vertical-align: middle;
                            // background-color: grey;
                            text-align: center;
                            height: .33rem;
                            line-height: 1.2;
                        }
                    }
                }
                &:nth-child(3n) {
                    margin-right: .5rem;
                }
            }
        }
    }
    #agenda-bg-area{
    }
    .agenda{
        .agenda-item-0{
            // background-image: url('http://static-image.xfz.cn/explore/2017cusc/m-bg-1.png');
            background-repeat: no-repeat;
            background-position: 0 100px;
        }

        .agenda-item-2{
            // background-image: url('http://static-image.xfz.cn/explore/2017cusc/m-bg-2.png');
            background-repeat: no-repeat;
            background-position: 0 0px;
        }
        .conf-host{
            margin:0 .12rem;
            color: #fff;
            .title{
                display: inline-block;
                font-size: .2rem;
                font-weight: bold;
                margin-bottom: .15rem;
                line-height: .2rem;
                background: {
                    image: url('../assets/n-pc/title-half-red-bg.png');
                    size: contain;
                    repeat: repeat-x;
                }
            }
            .summary{
                font-weight: bold;
                display: inline-block;
                margin-bottom: .1rem;
                border-radius: 6px;
                font-size: .14rem;
                padding: 6px;
            }
        }
        .agenad-list{
            font-size: 0px;
            margin-top: .16rem;
            width: 96%;
            margin: 0 auto;
        }
    }
    .tickets{
        width: 100%;
        margin-top: -40px;
        .s-title{
            margin-top: 80px;
        }
        .rogers-area {
            display: block;
            width: 90%;
            margin: 60px auto 20px;
            height: 2.6rem;
            position: relative;
            cursor: pointer;
            background-repeat: no-repeat;
            background-image:url( "../assets/n-m/m-rogers-bg.png");
            background-size: cover;
            text-decoration: none;
            .rogers {
                // border: 1px solid green;
                position: relative;
                display: inline-block;
                margin-left: -0.1rem;
                z-index: 99;
                img{
                    display: block;
                    margin-top: -.6rem;
                    width: 2rem;
                }
            }
            .ticket-info {
                // border: 1px solid green;
                position: relative;
                display: inline-block;
                vertical-align: top;
                margin-left: -.27rem;
                color: #fff;
                width: 1.7rem;
                padding-top: .1rem;
                .name {
                    font-size: .18rem;
                    font-weight: bold;
                }
                .price-line {
                    padding-top: .02rem;
                    .price {
                        background-color: #ec1c24;
                        display: inline-block;
                        padding:0 5px;
                        height: .18rem;
                        line-height: .18rem;
                        margin: 4px 0;
                        font-size: .18rem;
                        font-weight: bold;
                    }
                    span {
                        font-size: .13rem;
                        padding-left: .06rem;
                    }
                }
                .intro-line {
                    margin-left: .16rem;
                    ul {
                        margin-top: 4px;
                        list-style: disc outside;
                        li {
                            font-size: .12rem;
                            line-height: 1.6;
                        }
                    }
                }
            }

            .buy-btn{
                background-color: #ec1c24;
                color: #fff;
                font-weight: bold;
                text-align: center;
                width: .8rem;
                font-size: .14rem;
                border-radius: 2px;
                margin: 0 auto;
                margin-top: 4px;
                text-decoration: none;
                text-decoration: none;
            }

        }

        .tickets-content{
            img{
                display: block;
                margin: 10px auto;
                width: 90%;
            }
        }
        .tickets-content{
            width: 98%;
            padding: 10px 0;
            margin: 0 auto;
            text-align: center;
            a{
                display: inline-block;
                text-decoration: none;
            }
            .ticket0, .ticket2{
                background-image:url( "../assets/n-m/m-ticket-bg1.png");
                background-repeat: no-repeat;
                background-size: contain;
                text-decoration: none;
                margin-bottom: 10px;
                margin-right: 10px;
                width: 1.6rem;
                height: 2.4rem;
            }
            .ticket1, .ticket3{
                background-image:url( "../assets/n-m/m-ticket-bg2.png");
                background-repeat: no-repeat;
                background-size: contain;
                text-decoration: none;
                width: 1.6rem;
                height: 2.4rem;
            }
            .ticket-item{
                display: inline-block;
                height: 100%;
                vertical-align: top;
                padding: 10px 10px;
                color: #fff;
                position: relative;
                text-align: left;
                .name{
                    font-size: .18rem;
                    font-weight: bold;
                }
                .price{
                    background-color: #ec1c24;
                    display: inline-block;
                    padding:0 5px;
                    height: .18rem;
                    line-height: .18rem;
                    margin: 4px 0;
                    font-size: .18rem;
                    font-weight: bold;
                }
                .content{
                    font-size: .12rem;
                    line-height: 1.4;
                    text-align: left;
                }
                .bottom-area{
                    bottom: 15px;
                    left: 50%;
                    position: absolute;
                    .seat{
                        margin-left: -100%;
                        text-align: center;
                        font-size: .12rem;
                        padding-top: .14rem;
                    }
                    .buy-btn{
                        background-color: #ec1c24;
                        color: #fff;
                        font-weight: bold;
                        text-align: center;
                        width: .8rem;
                        font-size: .14rem;
                        border-radius: 2px;
                        margin: 0 auto;
                        margin-top: 4px;
                        margin-left: -50%;
                    }
                }
            }
        }
    }
    .old-guests{
        .container{
            text-align: center;
            margin: 0 auto;
            .old-guest-item{
                display: inline-block;
                width: .84rem;
                color: #ec1c24;
                text-align: center;
                margin-bottom: 15px;
                margin-right: .05rem;
                vertical-align: top;
                img{
                    width: .8rem;
                }
                .guest-name{
                    font-size: .12rem;
                }
                .guest-title{
                    font-size: .1rem;
                }
            }
        }
        .container :nth-child(4n){
            margin-right: 0px;
        }
    }
    .faq{
        .container{
            margin: 0 auto;
            width: 90%;
            color: #fff;
            font-size: .14rem;
            .line-a{
                margin-bottom: 10px;
            }
            .line-q, .line-a{
                span{
                    font-size: .18rem;
                    color: #ec1c24;
                    padding-right: 4px;
                    vertical-align: top;
                }
                .content{
                    padding-top: 2px;
                    display: inline-block;
                    max-width: 90%;
                }
            }
            .faq-more-btn{
                cursor: pointer;
                color: #ec1c24;
                text-align: center;
                margin-left: 0px;
                margin-bottom: 25px;
            }
            .sa-title{
                font-size: .18rem;
                color: #ec1c24;
            }
            .sa-content{
                margin-bottom: 10px;
            }
        }
    }
    .partners{
        color: #ec1c24;
        margin-bottom: 20px;
        .container{
            margin-top: -20px;
        }
        dl {
            margin-left: .14rem;
            margin-top: .2rem;
            display: inline-block;
            dt {
                font-size: .18rem;
                font-weight: bold;
                padding-left: .0rem;
                margin: 0 auto;
                line-height: .2rem;
                margin-bottom: .1rem;
            }
            dd {
                display: block;
                // text-align: center;
                margin-bottom: .2rem;
                img {
                    height: .4rem;
                    border: solid 0px #ccc;
                    margin-right: .087rem;
                    margin-bottom: .08rem;
                }
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
    .location{
        .location-wrap{
            position: relative;
            width: 95%;
            margin: 0 auto;
            margin-top: 10px;
            min-height: 2.4rem;
            background: {
                image: url('../assets/n-m/m-map.png');
                size: 100%;
                repeat: no-repeat;
            }
        }
        .address-info{
            text-align:left;
            padding:20px;
            color: #ffff00;
            font-size:0.14rem;
        }
    }
    .about-us{
        .about-us-wrap{
            width: 95%;
            color: #00ffff;
            margin: 0 auto;
            .user-item{
                margin-bottom: .2rem;
                width: 45%;
                margin-top: .1rem;
                margin-right: .1rem;
                display: inline-block;
                .title{
                    color: #ec1c24;
                    font-size: .2rem;
                    height: .2rem;
                    font-weight: bold;
                    line-height: .2rem;
                    padding-left: .1rem;
                    margin-bottom: 10px;
                }
                .name, .phone, .email{
                    font-size: .15rem;
                    color: #fff;
                    display: block;
                    margin-right: .1rem;
                    padding-left: .1rem;
                }
            }
        }
        .qrcode{
            color: #fff;
            text-align: center;
            margin-top: .3rem;
            padding-bottom: .5rem;
            img{
                display: block;
                width: 1rem;
                margin: 0 auto;
            }
        }
    }
    .section{
        .s-title{
            width: .5rem;
            text-align: center;
            padding: .1rem;
            img{
                height: .22rem;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-active {
        opacity: 0
    }
    .bottom-buy-link-float{
        transition: opacity .5s;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;

        position: fixed;
        cursor: pointer;
        left: 0;
        height: .44rem;
        right: 0;
        bottom: 0;
        z-index: 99;
        background-image: url("../assets/n-m/m-news-video.png");
        background-repeat: repeat-x;
        background-size: contain;
        // background-color: red;
        .bottom-nav-link{
            // background-color: grey;
            display: inline-block;
            width: 32%;
            height: 100%;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
    .no-more-invoice {
        vertical-align: top;
        color: red;
        display: inline-block;
        font-size: 20px;
        padding-top: 10px;
        padding-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// HomeMobile.vue?82df883a